import * as React from 'react';
export const ToastRootContext = /*#__PURE__*/React.createContext(undefined);
export function useToastRootContext() {
  const context = React.useContext(ToastRootContext);
  if (!context) {
    throw new Error('useToastRoot must be used within a ToastRoot');
  }
  return context;
}